import { z } from "zod";

export const sensorRequestApplianceDtoSchema = z.object({
  csLinkId: z.number(),
  interfaceName: z.string().nullable(),
  localisation: z.string().nullable(),
});

export const sensorRequestDtoSchema = z.object({
  id: z.number(),
  amount: z.number().nullable(),
  comment: z.string().nullable(),
  appliances: z.array(sensorRequestApplianceDtoSchema),
  creationDatetime: z.coerce.date(),
  personId: z.number(),
  subSiteId: z.number(),
});

export type TSensorRequestDto = z.infer<typeof sensorRequestDtoSchema>;
export type TSensorRequestApplianceDto = z.infer<typeof sensorRequestApplianceDtoSchema>;
